var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('Start'),_c('Contact'),_c('Services'),_c('Projects'),_c('Team'),_c('Carrier')],1)}
var staticRenderFns = []

export { render, staticRenderFns }